'use es6';

import { SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Subscription = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_, hasScope) => hasScope('subscriptions-access'),
  objectTypeId: SUBSCRIPTION_TYPE_ID,
  referenceObjectType: 'SUBSCRIPTION_PROPERTIES'
});
export default Subscription;